import { SearchApiScheduleType } from '@/app/(main)/(pages)/_types/search-api-response.type';

const searchApiScheduleTypes: SearchApiScheduleType[] = [
  SearchApiScheduleType.SCHEDULED,
  SearchApiScheduleType.ARRIVAL_ORDER,
  SearchApiScheduleType.FLEX,
  SearchApiScheduleType.LABORATORIAL,
];

export type SearchApiScheduleTypeFlags = Partial<Record<SearchApiScheduleType, boolean>>;

export function toSearchApiScheduleTypes(flags: SearchApiScheduleTypeFlags): SearchApiScheduleType[] | undefined {
  const selected = searchApiScheduleTypes.filter((scheduleType) => flags[scheduleType]);

  return selected.length > 0 ? selected : undefined;
}
